<template>
  <div class="map-editor">
    <div class="map-editor__container">
      <editor-layer-header :editor-state="editorState" />
      <div class="map-editor__subcontainer">
        <div class="map-editor__controls">
          <el-button
            class="r-button map-editor__controls-button"
            size="mini"
            type="primary"
            @click="closeButtonHandler(null)"
          >
            {{
              editorState.history.length
                ? "Сохранить и выйти"
                : "Выйти из редактора"
            }}
          </el-button>
          <el-button
            v-if="editorState.history.length"
            class="r-button map-editor__controls-button"
            :loading="editorState.loading"
            size="mini"
            type="success"
            @click="saveData"
          >
            Сохранить изменения
          </el-button>
          <el-button
            v-if="editorState.history.length"
            class="r-button map-editor__controls-button"
            size="mini"
            @click="clearEditingState"
          >
            Отменить изменения
          </el-button>
        </div>
        <editor-mode-switcher
          :editor-state="editorState"
          @toggle-editor-mode="toggleEditorMode"
        />
        <editor-model-controls
          :editor-state="editorState"
          @toggle-editing-model-layer="toggleEditingModelLayer"
          @toggle-visible-model-layer="toggleVisibleModelLayer"
        />

        <editor-history
          :editor-state="editorState"
          @change-history-step="changeHistoryStep"
          @clear-editing-state="clearEditingState"
        />
      </div>
    </div>
    <editor-help :editor-state="editorState" />
  </div>
</template>

<script>
import EditorLayerHeader from "./editor-layer-header";
import EditorModeSwitcher from "./editor-mode-switcher";
import EditorModelControls from "./editor-model-controls";
import EditorHistory from "./editor-history";
import EditorHelp from "./editor-help";

export default {
  props: [
    "map",
    "draw",
    "editor-state",
    "editor-controller",
    "layer-controller"
  ],
  data() {
    return {
      deleteModal: false
    };
  },
  components: {
    EditorLayerHeader,
    EditorModeSwitcher,
    EditorModelControls,
    EditorHistory,
    EditorHelp
  },
  methods: {
    // editor helpers
    closeButtonHandler(data) {
      this.editorController.closeButtonHandler(data);
    },
    toggleEditorMode(mode) {
      this.editorController.toggleEditorMode(mode);
    },
    changeHistoryStep(type) {
      this.editorController.changeHistoryStep(type);
    },
    clearEditingState() {
      this.editorController.clearEditingState();
    },
    saveData() {
      this.editorController.saveData();
    },
    // editor model handlers
    toggleEditingModelLayer(id) {
      this.editorController.toggleEditingModelLayer(id);
    },
    toggleVisibleModelLayer({ id, e }) {
      e.stopPropagation();
      this.editorController.toggleVisibleModelLayer(id);
    }
  }
};
</script>

<style lang="scss">
.map-editor {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;

  &__container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &__subcontainer {
    padding: 8px;
  }

  &__controls {
    margin-bottom: 16px;

    &-button {
      display: block;
      width: 100%;
      margin: 0 !important;

      &:not(:first-child) {
        margin-top: 10px !important;
      }
    }
  }
}
</style>
